import { useNavigate } from 'react-router-dom'
import { DropdownItem } from 'reactstrap'
import { gql } from '@apollo/client'
import { setLoginItem } from '../../utils'
import { SET_USER_ATTRIBUTE_MUTATION } from '../../graphql'

export const USER_ATTRIBUTE_MUTATION = gql(SET_USER_ATTRIBUTE_MUTATION)

export default function WorkspaceMenuItem({ item }) {
  //console.log(`WorkspaceMenuItem rendered: ${item.name}`)

  const navigate = useNavigate()
  async function handleSelect(workspaceId) {
    await window.apolloClient.mutate({ mutation: USER_ATTRIBUTE_MUTATION, variables: { attributeName: 'Current Workspace', attributeValue: workspaceId } })
    setLoginItem('currentWorkspaceId', workspaceId)
    navigate('/home')
  }

  return (
    <DropdownItem data-cy={`workspace-menu-item-${item.name.toLowerCase().replace(/ /g,'-')}`} onClick={() => handleSelect(item.id)}>{item.name}</DropdownItem>
  )
}
